import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { PageNotFoundComponent } from 'src/app/pages/page-not-found/page-not-found.component';

const routes: Routes = [
  {
    path: 'welcome',
    redirectTo: '',
    pathMatch: 'full'
  },
  {
    path: 'login',
    loadChildren: () =>
      import('src/app/pages/users/sign-in/sign-in.module').then((m) => m.SignInModule),
  },
  {
    path: 'login-admin',
    loadChildren: () =>
      import('src/app/pages/users/sign-in-tecnico/sign-in-tecnico.module').then(
        (m) => m.SignInTecnicoModule),
  },
  {
    path: 'changePassword',
    loadChildren: () =>
      import('src/app/pages/users/change-password/change-password.module').then((m) => m.ChangePasswordModule),
  },
  {
    path: 'two-factor',
    loadChildren: () =>
      import('src/app/pages/users/two-factor/two-factor.module').then((m) => m.TwoFactorModule),
  },
  {
    path: 'confirm-email',
    loadChildren: () =>
      import('src/app/pages/users/confirm-email/confirm-email.module').then((m) => m.ConfirmEmailModule),
  },
  {
    path: 'login-tecnico',
    loadChildren: () =>
      import('src/app/pages/users/sign-in-tecnico/sign-in-tecnico.module').then(
        (m) => m.SignInTecnicoModule),
  },
  {
    path: 'forgotPassword',
    loadChildren: () =>
      import('src/app/pages/users/forgot-password/forgot-password.module').then((m) => m.ForgotPasswordModule),
  },
  {
    path: 'register',
    loadChildren: () =>
      import('src/app/pages/users/register/register.module').then(
        (m) => m.RegisterModule),
  },
  {
    path: 'available-transactions',
    loadChildren: () =>
      import('src/app/pages/sub-category/sub-category.module').then((m) => m.SubCategoryModule),
  },
  {
    path: '',
    loadChildren: () =>
      import('src/app/pages/sub-category/sub-category.module').then((m) => m.SubCategoryModule),
  },
  {
    path: 'transaction-type',
    loadChildren: () =>
      import('src/app/pages/transaction-type-detail/transaction-type-detail.module').then(
        (m) => m.TransactionTypeDetailModule
      ),
  },
  {
    path: 'transaction-type/profile',
    loadChildren: () =>
      import('src/app/pages/profile-picker/profile-picker.module').then(
        (m) => m.ProfilePickerModule
      ),
  },
  {
    path: 'transaction-type/parent-list',
    loadChildren: () =>
      import('src/app/pages/transaction-parent-list/transaction-parent-list.module').then(
        (m) => m.TransactionParentListModule
      ),
  },

  {
    path: 'transactions',
    loadChildren: () =>
      import('src/app/pages/transaction/transaction-management.module').then(
        (m) => m.TransactionManagementModule
      ),
  },
  {
    path: 'transactions-admin',
    loadChildren: () =>
      import('src/app/pages/transaction-admin/transaction-admin-management.module').then(
        (m) => m.TransactionAdminManagementModule
      ),
  },
  {
    path: 'transaction-receipt',
    loadChildren: () =>
      import('src/app/pages/transaction-receipt/transaction-receipt.module').then(
        (m) => m.TransactionReceiptModule
      ),
  },
  {
    path: 'transaction-plan-receipt',
    loadChildren: () =>
      import('src/app/pages/transaction-plan-receipt/transaction-plan-receipt.module').then(
        (m) => m.TransactionPlanReceiptModule
      ),
  },
  {
    path: 'shopping-cart',
    loadChildren: () =>
      import('./pages/shopping-cart/shopping-cart.module').then(
        (m) => m.ShoppingCartModule
      ),
  },
  /*
    {
      path: 'reports',
      loadChildren: () =>
        import('src/app/pages/reports/reports.module').then(
          (m) => m.ReportsModule
        ),
    },
    {
      path: 'my-certifications',
      loadChildren: () =>
        import('src/app/pages/my-certifications/my-certifications.module').then(
          (m) => m.MyCertificationsModule
        ),
    },
  */
  {
    path: 'account',
    loadChildren: () =>
      import('src/app/pages/account/account.module').then((m) => m.AccountModule),
  },
  {
    path: 'credit-purchase',
    loadChildren: () =>
      import('src/app/pages/credit/credit.module').then((m) => m.CreditModule),
  },
  {
    path: 'fine-list',
    loadChildren: () =>
      import('src/app/pages/fine/external-fine.module').then((m) => m.ExternalFineModule),
  },
  {
    path: 'privacy',
    loadChildren: () =>
      import('src/app/pages/shared/privacy/privacy.module').then((m) => m.PrivacyModule),
  },
  {
    path: 'terms',
    loadChildren: () =>
      import('src/app/pages/shared/terms/terms.module').then((m) => m.TermsModule),
  },
  {
    path: 'user-process-document-request/requestId/:id',
    loadChildren: () =>
      import('src/app/pages/shared/transaction-supplementary-documents-list/transaction-supplementary-documents-list.module').then((m) => m.TransactionSupplementaryDocumentsListModule),
  },

  // {
  //   path: '',
  //   loadChildren: () =>
  //     import('src/app/pages/category-detail/category-detail.module').then((m) => m.CategoryDetailModule),
  // },
  /*   {
      path: 'certifications',
      loadChildren: () =>
        import('./pages/certifications/certification.module').then((m) => m.CertificationsModule),
    },   */

  {
    path: 'franchises',
    loadChildren: () =>
      import('src/app/pages/franchises/franchises.module').then(
        (m) => m.FranchisesModule
      ),
  },
  {
    path: 'medical-certificates',
    loadChildren: () =>import('src/app/pages/medical-certificate/medical-certificate.module').then((m) => m.MedicalCertificateModule),
  },
  {
    path: 'my-request',
    loadChildren: () =>import('src/app/pages/my-request/my-request.module').then((m) => m.MyRequestModule),
  },
  {
    path: 'medical-profile',
    loadChildren: () =>import('src/app/pages/licesing-discipline-form/licesing-discipline-form.module').then((m) => m.LicesingDisciplineFormModule),
  },
  {
    path: 'medical-registration-renewal',
    loadChildren: () => import('src/app/pages/medical-registration-renewal-request/medical-registration-renewal-request.module').then((m) => m.MedicalRegistrationRenewalRequestModule),
  },
  {
    path: 'qrcode/validateCertificate/:id',
    loadChildren: () =>import('src/app/pages/certificate-qr-validation/certificate-qr-validation.module')
    .then((m) => m.CertificateQrValidationModule),
  },
  {
    path: 'qrcode/:id',
    loadChildren: () =>import('src/app/pages/user-process-qr-validation/user-process-qr-validation.module')
    .then((m) => m.UserProcessQrValidationModule),
  },
  // {
  //   path: 'medical-professional-search',
  //   loadChildren: () => import('src/app/core/components/citizen-doctor-search/citizen-doctor-search.module')
  //     .then(m => m.CitizenDoctorSearchModule)
  // },
  // {
  //   path: 'operational-dashboard',
  //   loadChildren: () =>
  //     import('src/app/pages/operational-dashboard/operational-dashboard.module').then(
  //       (m) => m.OperationalDashboardModule
  //     ),
  // },
  { path: '**', component: PageNotFoundComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
